// extracted by mini-css-extract-plugin
module.exports = {"empty-background":"_2-xIz","emptyBackground":"_2-xIz"};